
















































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { AchContributionRecord } from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import { Location } from "vue-router";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import { useAchContributionStore } from "@/employer/store/achContribution";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Button,
    Pagination,
    ContributionsNavigation
  }
})
export default class AchContributions extends Vue {
  achContributionStore = useAchContributionStore();
  userStore = useUserStore();

  formatCurrency = formatCurrency;

  @Prop()
  page: number;

  @Prop()
  routeToAchContributions: (page: number) => Location;

  mounted (): void {
    this.loadAchRecords();
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.loadAchRecords();
  }

  loadAchRecords (): void {
    this.achContributionStore.loadRecords({ id: this.userStore.currentEmployer.employerId, pageNumber: this.page } as any);
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToAchContributions(toPage));
  }

  downloadEmployeeContributions (achReportId: number) {
    this.achContributionStore.downloadEmployeeDisbursalReport(achReportId);
  }

  downloadEmployeeHoldOverReport (processPayDate: string) {
    this.achContributionStore.downloadProcessedEmployeeHoldOverReport(processPayDate);
  }

  selectFile (event, file: AchContributionRecord): void {
    event.preventDefault();
    this.achContributionStore.setSelectedFile(file);
  }

  get hasNoDataToDisplay () {
    return !this.achContributionStore.achRecordsByPageNumber.length;
  }

  currencyDisplayWithAsterisk (amount: number): string {
    if (!amount) {
      return "**";
    }

    return formatCurrency(amount);
  }
}
